import SeniorAdjacentIndustires from 'sly/partners/seniorAdjacentIndustries';

export const getServerSideProps = () => ({ props: {} });

export default SeniorAdjacentIndustires;
